<template>
    <modal @close="$emit('close')" :minWidthPx="'750'">
        <div class="text-main-text text-left font-normal pb-6 px-10 text-sm">
            <h3 class="text-2xl mb-10">Добавление команды</h3>

            <MozInput v-model="form.team" type="text" placeholder="Название команды" class="mb-8 w-2/5"
                :error="form.errors.first('team')" />

            <MozInput v-model="form.captain_name" type="text" placeholder="Контактное лицо" class="mb-2 w-2/5"
                :error="form.errors.first('captain_name')" />

            <div class="flex justify-between mb-8">
                <MozInput v-model="form.captain_phone" type="tel" inputmode="tel" placeholder="Телефон для связи" class="mr-4"
                    :error="form.errors.first('captain_phone')" />
                <MozInput v-model="form.captain_email" type="text" placeholder="E-mail" class="mr-4"
                    :error="form.errors.first('captain_email')" />
                <MozInput v-model="form.player_count" type="text" placeholder="Игроков" class="mr-4"
                    :error="form.errors.first('player_count')" />
                <MozInput v-model="form.summ" type="text" placeholder="К оплате" class=""
                    :error="form.errors.first('summ')" />
            </div>

            <div v-if="isCorpLeague">
                <MozInput v-model="company.name" type="text" placeholder="Название компании" class="w-full mb-10"
                    :error="form.errors.first('company.name')" />
                <MozInput v-model="company.comment" type="text" placeholder="Краткая информация" class="w-full mb-10"
                    :error="form.errors.first('company.comment')" />
            </div>


            <MozInput v-model="form.comment" type="text" placeholder="Комментарий" class="w-full mb-10"
                :error="form.errors.first('form.comment')" />

            <div v-if="isCorpLeague">

                <vue-upload-component ref="upload" class="upl" v-model="uploadedCompanyLogos" :multiple="true" :drop="true" :drop-directory="true"
                    :thread="5" :maximum="5" @input-filter="inputFilter">
                    <slot v-if="uploadedCompanyLogos.length<5">
                        <div class="flex flex-row items-center cursor-pointer h-8">
                            <div  @click="addLogoClick"
                                class="hover-up outline-none rounded-full flex flex-row justify-center items-center h-8 w-8 bg-brand-light cursor-pointer">
                                <font-awesome-icon class="text-white text-xl" :icon="['fal', 'plus']">
                                </font-awesome-icon>
                            </div>
                            <div class="text-xs text-additional-text font-bold ml-4">Добавить логотип компании</div>
                        </div>
                    </slot>
                    <slot v-else>
                        <div class="mx-5 mt-5 h-8 cursor-pointer">
                        </div>
                    </slot>
                </vue-upload-component>

                <div class="w-full flex items-center my-6">
                    <div v-for="image in uploadedCompanyLogos" :key="image.id" class="image-cont w-24 h-24 mr-4 border" @click="deleteUploadedLogo(image)">
                        <img :src="getUrlObject(image)" class="image">
                        <div class="image-shadow"><img class="w-6 h-6" src="@/assets/SVG/trash-bin-white.svg" alt /></div>
                    </div>
                </div>
                <span v-show="fileFormatError" class="text-red text-10px md:text-xs font-normal"
                            v-text="'Неверный формат файлов'"></span>
            </div>

            <div class="flex justify-end">
                <button class="button hover-up" @click.prevent ="save">
                    Добавить команду
                </button>
            </div>

        </div>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/modals.js';
import Modal from '@/views/modals/base-modal-white';
import MozInput from '@/helpers/input_material_like';
import Form from 'form-backend-validation';
import client from '@/clients/player';
import VueUploadComponent from 'vue-upload-component';


export default {
  name: 'AddingTeamModal',
  components: {
    Modal,
    MozInput,
    VueUploadComponent,
  },
  mixins: [ModalMixin],
  props: ['isCorpLeague'],

  data() {
    return {
      form: new Form({
        team: '',
        captain_name: '',
        captain_phone: '',
        captain_email: '',
        player_count: '',
        summ: '',
        comment: '',
        company: null,
      }, { http: client }),
      company: {
        name: '',
        comment: '',
      },
      uploadedCompanyLogos: [],
      fileFormatError: false,
    };
  },

  methods: {
    getUrlObject(logoUploadObject) {
      return URL.createObjectURL(logoUploadObject.file);
    },

    deleteUploadedLogo(file) {
      this.$refs.upload.remove(file);
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter non-image file
        // Will not be added to files
        if (!/\.(jpg|png|psd|ai|svg)$/i.test(newFile.name)) {
          this.fileFormatError = true;
          return prevent();
        }

        if (this.uploadedCompanyLogos.length > 5) {
          return prevent();
        }
      }
    },

    save() {
      if (this.isCorpLeague) {
        this.form.company = this.company;
        this.form.company.media = this.uploadedCompanyLogos.map(item => item.file);
      }
      this.form.post('/application');
    },

    addLogoClick() {
      const label = document.querySelector('.upl input');
      console.dir(label);
      label.click();
      this.fileFormatError = false;
    },

  },

};

</script>

<style scoped>


 .button {
     @apply font-semibold;
        border-radius: 28px;
        border: 1px solid rgba(151, 151, 151, 0);
        background-color: #bd006c;
        outline: none;
        color: white;
        padding: 0.7rem 2rem;
    }

.image-cont {
  @apply flex justify-center items-center relative;
  border-radius: 0.25rem;
}

.image {
    border-radius: 0.25rem;
    z-index: 0;
  }

  .image-shadow {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.726);
    border-radius: 0.25rem;
    color: white;
    display: flex;
    font-size: 0.875rem;
    justify-content: center;
    align-items: center;
    opacity: 0;
  }

  .image-shadow:hover {
      opacity: 1;
      color: transparent;
      cursor: pointer;
    }

  .upl>>>label {
    z-index: -1 !important;
    cursor: pointer;
  }
</style>
